<template>
  <div class="alpha-shield-pro">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex> \$2\$ </div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage dark-stage">
        <div class="hud-panel">
          <div class="hud-item cyan">
            <label>粒子能量</label>
            <span class="val">{{ energy.toFixed(1) }} <small>MeV</small></span>
          </div>
          <div class="hud-item orange">
            <label>屏蔽效能 (一张纸)</label>
            <span class="val">100% 阻断</span>
          </div>
        </div>

        <svg width="100%" height="240" viewBox="0 0 450 240" preserveAspectRatio="xMidYMid meet">
          <!-- 屏蔽层: 一张纸 (Paper) -->
          <rect x="220" y="40" width="8" height="160" fill="#f8fafc" stroke="#334155" />
          <text x="224" y="215" text-anchor="middle" fill="#64748b" font-size="10">一张纸 (Paper)</text>

          <!-- 粒子流发射 (Emitter) -->
          <g transform="translate(40, 120)">
             <rect x="-20" y="-15" width="40" height="30" fill="#334155" />
             <text x="0" y="30" text-anchor="middle" fill="#94a3b8" font-size="9">α 放射源</text>
          </g>

          <!-- 飞行的 Alpha 粒子 (氦核：2中2质) -->
          <g v-for="p in particles" :key="p.id">
             <circle :cx="p.x" :cy="p.y" r="4" fill="#fbbf24" filter="url(#glow-a)" />
             <path v-if="p.isBlocked" :d="`M ${p.x-5},${p.y-5} L ${p.x+5},${p.y+5} M ${p.x+5},${p.y-5} L ${p.x-5},${p.y+5}`" stroke="#f43f5e" stroke-width="2" />
          </g>

          <defs>
             <filter id="glow-a"><feGaussianBlur stdDeviation="2" result="blur"/><feComposite in="SourceGraphic" in2="blur" operator="over"/></filter>
          </defs>
        </svg>

        <div class="physics-caption">
           现象：Alpha 射线质量大、带电量多，一张普通的纸即可轻易将其完全阻拦。
        </div>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="flex-row items-center gap-6">
              <div class="flex-1">
                 <label class="s-label">调节放射源强度 (粒子流量)：{{ (particles.length).toFixed(0) }}</label>
                 <el-slider v-model="intensity" :min="1" :max="10" size="small"></el-slider>
              </div>
              <div class="btn-group">
                 <el-button type="primary" size="small" @click="ignite">启动实验</el-button>
                 <el-button size="small" @click="reset">重置</el-button>
              </div>
           </div>
        </div>
        <div class="discovery-card-discovery" v-latex>
           <i class="el-icon-circle-close"></i>
           <p><strong>实战物理：</strong>Alpha 射线是带正电的氦核流。<strong>关键观察：</strong>虽然它电离能力极强，但**穿透力极弱**。你会看到所有的粒子在触碰“纸张”的一瞬间被完全吸收（变红 X）。这也就是为什么只要不吸入体内，Alpha 放射源对人体外部相对安全。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'AlphaRayShieldingViz',
  data() {
    return {
      energy: 5.5,
      intensity: 3,
      particles: [],
      isRunning: false,
      nextId: 0
    }
  },
  methods: {
    ignite() { this.isRunning = true; this.animate(); },
    animate() {
       if (!this.isRunning) return;
       // Spawn
       if (Math.random() < this.intensity * 0.1) {
          this.particles.push({ id: this.nextId++, x: 40, y: 120 + (Math.random()-0.5)*40, vx: 4, isBlocked: false });
       }
       // Move
       for(let i=this.particles.length-1; i>=0; i--) {
          const p = this.particles[i];
          if (!p.isBlocked) p.x += p.vx;
          
          if (p.x > 220 && !p.isBlocked) {
             p.isBlocked = true;
             p.x = 222 + Math.random()*2;
             setTimeout(() => { this.particles.splice(this.particles.indexOf(p), 1); }, 800);
          }
       }
       this.animFrame = requestAnimationFrame(this.animate);
    },
    reset() { this.particles = []; this.isRunning = false; cancelAnimationFrame(this.animFrame); }
  },
  beforeDestroy() {
    this.isRunning = false;
    cancelAnimationFrame(this.animFrame);
  }
}
</script>

<style scoped lang="scss">
@import "./PhysicsCommon.scss";
.alpha-shield-pro { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
</style>
